import { createListenerMiddleware } from '@reduxjs/toolkit'
import { initCartProductUpdateOnTokenFetchListener } from '@redux/listeners/claim-record-update/cartProductUpdateOnTokenFetchListener'
import { initClaimRecordUpdateListener } from '@redux/listeners/claim-record-update/claimRecordUpdateListener'
import { initLocalCustomerContextStateListener } from '@redux/listeners/localCustomerContextStateListener'
import { initLocalFormStateListener } from '@redux/listeners/localFormStateListener'

export const listenerMiddleware = createListenerMiddleware()

initCartProductUpdateOnTokenFetchListener(listenerMiddleware)
initClaimRecordUpdateListener(listenerMiddleware)
initLocalFormStateListener(listenerMiddleware)
initLocalCustomerContextStateListener(listenerMiddleware)
